import React from "react";
import styled from "styled-components";
import { Text, PopupMenu, Flex, Input, Button, Item, Box } from "@thenounproject/lingo-core";

import { useColorCopy, ColorFormat } from "./hooks";

const ExportTitle = styled(Text).attrs({
  font: "ui.smallBold",
  mb: "s",
})``;

const COLOR_FORMATS: ColorFormat[] = ["hex", "rgb", "hsb", "pms", "cmyk"];

type Props = {
  item: Item;
  close: () => void;
  position: {
    xPos: number | string;
    yPos: number | string;
  };
};

/**
 * Presentational menu component for color copy options
 */
const ColorExportMenu: React.FC<Props> = ({ item, close, position }) => {
  const { asset } = item;
  const { copyColor, getColorValue, isFormatAvailable, lastCopiedFormat } = useColorCopy(
    asset,
    item
  );

  const popupSource = "color-export-menu";
  const { xPos, yPos } = position;

  return (
    <>
      <PopupMenu.ContextMenuAnchor xPos={xPos} yPos={yPos} data-popup-source={popupSource} />
      <PopupMenu source={popupSource} close={close} stayOpenOnClick width={287}>
        <Box p="m">
          <ExportTitle>Copy as</ExportTitle>
          {COLOR_FORMATS.map(format => {
            if (!isFormatAvailable(format)) return null;

            const value = getColorValue(format);
            const wasCopied = lastCopiedFormat === format;
            const buttonIconStyle = wasCopied
              ? { tintColor: "success" as const, icon: "checkmark" }
              : { icon: "clipboard" };

            return (
              <Flex mb="xs" key={format}>
                <Input value={value} type="text" readOnly />
                <Button
                  onClick={() => copyColor(format)}
                  buttonStyle="tertiary"
                  size="small"
                  themeOverrides={{ primaryColor: "black" }}
                  pl="s"
                  {...buttonIconStyle}
                />
              </Flex>
            );
          })}
        </Box>
      </PopupMenu>
    </>
  );
};

export default ColorExportMenu;
